import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
//import { post } from 'jquery';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

declare var google;
@Component({
  selector: 'adf-income-details-form',
  templateUrl: 'income_details.html',
  providers: [EnvDataService]
})
export class IncomeDetails {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();
  @ViewChild('myInput')
  myInputVariable: ElementRef;

  callMethod() {
    alert('successfully executed.')
    console.log('successfully executed.');
    //this.test++;
  }

  public autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');
  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2,
    suffix: ' '
  })

  incomeForm: FormGroup;

  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  public change_log_string: any;
  public indexx: number;
  public percentage_0: any;
  public percentage_1: any;
  public percentage_2: any;
  public percentage_3: any;
  public percentage_4: any;
  public percentage_5: any;
  public allIncomess: any;
  public income_details: any;
  public date:any;
  public showPrimaryApplicantEmployement: number = 1;
  public showAdditional_employement: number = -1;
  public incomeoption = [];
  public uploadProgress:number= 0;
  public upload_index:number = 0;
  public fileuploadstatus:boolean = true;

  public validation_messages = {
    'amount': [
      { type: 'required', message: 'This field is required.' }
    ],
    'frequency': [
      { type: 'required', message: 'This field is required.' }
    ],
    'date_commenced': [
      { type: 'required', message: 'This field is required.' }
    ],
    'sallary_payslip_0':[
      { type: 'required', message: 'This field is required.' }
    ]

  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public alertCtrl: AlertController,
    public SdfFormService: SdfFormService,
    private storage: AngularFireStorage,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];
    this.allIncomess = [];
    this.income_details = [];

    this.incomeForm = formBuilder.group({
      itemRows: formBuilder.array([]),
      addApplicantIncomeItem: formBuilder.array([])
    });


  }
  ngOnInit() {
  }

  addAnotherApplicant() {
    this.formApplicantIncome.push(this.initItemRowsBlank());
  }

  initItemRowsBlank() {
    return this.formBuilder.group({
      itemRows: this.formBuilder.array([])
    });
  }

  initItemRows() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      type: ['Salary', Validators.compose([Validators.maxLength(30)])],
      amount: ['', Validators.compose([Validators.maxLength(30)])],
      receive_overtime: ['', Validators.compose([Validators.maxLength(30)])],
      receive_commissions_bounses: ['', Validators.compose([Validators.maxLength(30)])],
      receive_moter_vehicle_allowance: ['', Validators.compose([Validators.maxLength(30)])],
      salary_sacrifice: ['', Validators.compose([Validators.maxLength(30)])],
      any_other_allowances: ['', Validators.compose([Validators.maxLength(30)])],
      frequency: ['Annual', Validators.compose([Validators.maxLength(30)])],
      date_commenced: [this.date, Validators.compose([Validators.maxLength(30), Validators.required])],
      comments: [''],
      sallary_payslip_0: [''],
      sallary_payslip_1: [''],
      sallary_payslip_2: [''],
      sallary_payslip_3: [''],
      sallary_payslip_4: [''],
      sallary_payslip_5: [''],
      sallary_payslip_name_0: [''],
      sallary_payslip_name_1: [''],
      sallary_payslip_name_2: [''],
      sallary_payslip_name_3: [''],
      sallary_payslip_name_4: [''],
      sallary_payslip_name_5: [''],
      document_id: [''],
      deleted: [0]
    });
  }

  initItemRowsIncomesLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      type: [data.type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      amount: [data.amount, Validators.compose([Validators.maxLength(30)])],
      receive_overtime: [data.receive_overtime, Validators.compose([Validators.maxLength(30)])],
      receive_commissions_bounses: [data.receive_commissions_bounses, Validators.compose([Validators.maxLength(30)])],
      receive_moter_vehicle_allowance: [data.receive_moter_vehicle_allowance, Validators.compose([Validators.maxLength(30)])],
      salary_sacrifice: [data.salary_sacrifice, Validators.compose([Validators.maxLength(30)])],
      any_other_allowances: [data.any_other_allowances, Validators.compose([Validators.maxLength(30)])],
      frequency: [data.frequency, Validators.compose([Validators.maxLength(30)])],
      date_commenced: [data.date_commenced, Validators.compose([Validators.maxLength(30), Validators.required])],
      comments: [data.comments],
      sallary_payslip_0: [data.salary[0].payslip],
      sallary_payslip_1: [data.salary[1].payslip],
      sallary_payslip_2: [data.salary[2].payslip],
      sallary_payslip_3: [data.salary[3].payslip],
      sallary_payslip_4: [data.salary[4].payslip],
      sallary_payslip_5: [data.salary[5].payslip],
      sallary_payslip_name_0: [data.salary[0].payslip_name],
      sallary_payslip_name_1: [data.salary[1].payslip_name],
      sallary_payslip_name_2: [data.salary[2].payslip_name],
      sallary_payslip_name_3: [data.salary[3].payslip_name],
      sallary_payslip_name_4: [data.salary[4].payslip_name],
      sallary_payslip_name_5: [data.salary[5].payslip_name],
      document_id: [data.document_id],
      deleted: [data.deleted]
    });
  }


  ngOnChanges() {
    console.log('abc', this.editdata); // object here
    console.log(this.formArr.controls[0]);
    if (this.editdata.contact_details != undefined) {
      if (this.editdata.contact_details.employment_details != undefined) {
        var uData = this.editdata.contact_details.employment_details;
        var getDate = uData.start_date;
        if(getDate) {
          this.date = getDate;
        }
        if(this.editdata.contact_details.employment_details.incomes) {
          if (this.editdata.contact_details.employment_details.incomes.length > 0) {
            var editgetIncomes = this.editdata.contact_details.employment_details.incomes;
            if (editgetIncomes.length > 0 && this.formArr.length == 0) {
              editgetIncomes.forEach((uData,index) => {

                if(uData.date_commenced == '') {
                  uData.date_commenced=this.date;
                }



                this.incomeoption[index] = true;
                this.formArr.push(this.initItemRowsIncomesLoad(uData));
                if(uData.type == "Salary"){
                  if(this.userRole == 'contact') {
                    this.formArr.controls[index]['controls'].sallary_payslip_0.setValidators(Validators.required);
                    this.formArr.controls[index]['controls'].sallary_payslip_0.updateValueAndValidity();
                  }

                }
              })
            }
          }
        }

      }

    }

  }

  addIncomes() {
    this.formArr.push(this.initItemRows());
    this.indexx = this.formArr.controls.length - 1;
    if(this.userRole == 'contact') {
      this.formArr.controls[this.indexx]['controls'].sallary_payslip_0.setValidators(Validators.required);
      this.formArr.controls[this.indexx]['controls'].sallary_payslip_0.updateValueAndValidity();
    }

    //this.signupSlider.resize();
    //this.signupSlider.update();
  }
  addeventIncome(event) {
    debugger;
    if(event == 'yes') {

      this.formArr.push(this.initItemRows());
      if(this.userRole == 'contact') {
        this.formArr.controls[0]['controls'].sallary_payslip_0.setValidators(Validators.required);
        this.formArr.controls[0]['controls'].sallary_payslip_0.updateValueAndValidity();
      }

      this.incomeoption[0] = false;
    }
    else {
      this.incomeoption[0] = true;
      while (this.formArr.length !== 0) {
          this.formArr.removeAt(0);
        }

    }

  }
  addIncomesAdditional(index) {
    this.formApplicantIncome.controls[index]['controls']['itemRows'].push(this.initItemRows());
    //this.signupSlider.resize();
    //this.signupSlider.update();
  }


  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }
  //income section
  get formArr() {
    return this.incomeForm.get('itemRows') as FormArray;
  }
  get formApplicantIncome() {
    return this.incomeForm.get("addApplicantIncomeItem") as FormArray;
  }



  changeLog(event, index: any) {
    // let this = this;
    // var property = event.ngControl.name;
    // this.new_val = event._value;
    // this.old_val = '';
    // var new_property = '';

    // if(index == 'main'){
    //   if(property == 'firstname'){
    //     this.old_val = (this.applicant_details.firstname == undefined) ? '' : this.applicant_details.firstname;
    //     new_property = 'Firstname';
    //     this.firstname = this.new_val;
    //   }
    //   if(property == 'middlename'){
    //     this.old_val = (this.applicant_details.middlename == undefined) ? '' : this.applicant_details.middlename;
    //     new_property = 'Middlename';
    //   }
    //   if(property == 'lastname'){
    //     this.old_val = (this.applicant_details.lastname == undefined) ? '' : this.applicant_details.lastname;
    //     new_property = 'Lastname';
    //     this.lastname = this.new_val;
    //   }
    //   if(property == 'email'){
    //     this.old_val = (this.applicant_details.email == undefined) ? '' : this.applicant_details.email;
    //     new_property = 'Email';
    //     this.checkContact = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkContact = 0;
    //         }else{
    //           this.checkContact = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }
    //   if(property == 'mobile_phone'){
    //     this.old_val = (this.applicant_details.mobile_phone == undefined) ? '' : this.applicant_details.mobile_phone;
    //     new_property = 'Mobile Phone';
    //   }
    //   if(property == 'primayr_goal_intention'){
    //     this.old_val = (this.applicant_details.primayr_goal_intention == undefined) ? '' : this.applicant_details.primayr_goal_intention;
    //     new_property = 'Primary Goal Intention';
    //   }
    //   if(property == 'floor_number'){
    //     this.old_val = (this.applicant_details.floor_number == undefined) ? '' : this.applicant_details.floor_number;
    //     new_property = 'Floor Number';
    //   }
    //   if(property == 'unit_number'){
    //     this.old_val = (this.applicant_details.unit_number == undefined) ? '' : this.applicant_details.unit_number;
    //     new_property = 'Unit Number';
    //   }
    //   if(property == 'building_name'){
    //     this.old_val = (this.applicant_details.building_name == undefined) ? '' : this.applicant_details.building_name;
    //     new_property = 'Building Name';
    //   }
    //   if(property == 'street_number'){
    //     this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
    //     new_property = 'Street Number';
    //   }
    //   if(property == 'street_name'){
    //     this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
    //     new_property = 'Street Name';
    //   }
    //   if(property == 'city'){
    //     this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
    //     new_property = 'City';
    //   }
    //   if(property == 'postcode'){
    //     this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
    //     new_property = 'Postcode';
    //   }
    //   if(property == 'poboxlabel'){
    //     this.old_val = (this.applicant_details.poboxlabel == undefined) ? '' : this.applicant_details.poboxlabel;
    //     new_property = 'PO Box Label';
    //   }
    //   if(property == 'first_child_age'){
    //     this.old_val = (this.applicant_details.first_child_age == undefined) ? '' : this.applicant_details.first_child_age;
    //     new_property = 'First Child Age';
    //   }
    //   if(property == 'second_child_age'){
    //     this.old_val = (this.applicant_details.second_child_age == undefined) ? '' : this.applicant_details.second_child_age;
    //     new_property = 'Second Child Age';
    //   }
    //   if(property == 'third_child_age'){
    //     this.old_val = (this.applicant_details.third_child_age == undefined) ? '' : this.applicant_details.third_child_age;
    //     new_property = 'Third Child Age';
    //   }
    //   if(property == 'fourth_child_age'){
    //     this.old_val = (this.applicant_details.fourth_child_age == undefined) ? '' : this.applicant_details.fourth_child_age;
    //     new_property = 'Fourth Child Age';
    //   }
    //   if(property == 'fifth_child_age'){
    //     this.old_val = (this.applicant_details.fifth_child_age == undefined) ? '' : this.applicant_details.fifth_child_age;
    //     new_property = 'Fifth Child Age';
    //   }
    //   if(property == 'sixth_child_age'){
    //     this.old_val = (this.applicant_details.sixth_child_age == undefined) ? '' : this.applicant_details.sixth_child_age;
    //     new_property = 'Sixth Child Age';
    //   }
    //   if(property == 'your_occupation'){
    //     this.old_val = (this.employment_details.your_occupation == undefined) ? '' : this.employment_details.your_occupation;
    //     new_property = 'Your Occupation';
    //   }
    //   if(property == 'start_date'){
    //     this.old_val = (this.employment_details.start_date == undefined) ? '' : this.employment_details.start_date;
    //     new_property = 'Employment start date';
    //   }
    //   if(property == 'business_name'){
    //     this.old_val = (this.employment_details.business_name == undefined) ? '' : this.employment_details.business_name;
    //     new_property = 'Business Name';
    //   }
    //   if(property == 'type_of_entity'){
    //     this.old_val = (this.employment_details.type_of_entity == undefined) ? '' : this.employment_details.type_of_entity;
    //     new_property = 'Type of Entity';
    //   }
    //   if(property == 'abn_acn'){
    //     this.old_val = (this.employment_details.abn_acn == undefined) ? '' : this.employment_details.abn_acn;
    //     new_property = 'abn_acn';
    //   }
    //   if(property == 'nature_of_business'){
    //     this.old_val = (this.employment_details.nature_of_business == undefined) ? '' : this.employment_details.nature_of_business;
    //     new_property = 'Nature of Business';
    //   }
    // }else{
    //   if(property == 'secondary_email'){
    //     this.old_val = (this.secondary_details.secondary_email == undefined) ? '' : this.secondary_details.secondary_email;
    //     new_property = 'Email';
    //     this.checkAddiContact.push({'status': 0});
    //     this.checkAddiContact[index].status = 0;
    //     this.checkAddiContactStatus = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkAddiContact[index].status = 0;
    //         }else{
    //           this.checkAddiContact[index].status = 1;
    //           this.checkAddiContactStatus = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }

    // }



    // if(this.new_val != this.old_val){
    //   //this.change_log_string += property+'='+this.old_val+':'+this.new_val+';';
    //   this.change_log_string.push({'property' : new_property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    // }
  }

  deleteRestoreDocument(index: number, document_id: any, type: any, collection: any, status: any, index1: number) {
    let alert = this.alertCtrl.create({
      title: 'Confirm ' + status + ' ' + type,
      message: 'Are you sure you want to ' + status + ' this ' + type + ' ?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (document_id != "") {
              let deleted = 0;
              if (status == 'delete') {
                deleted = 1;
              }
              let postData = {
                'document_id': document_id,
                'collection': collection,
                'deleted': deleted,
                'deleted_date': new Date().getTime()
              }
              this.SdfFormService.deleteDocument(postData);
              if (status == 'delete') {
                if (type == 'income') {
                  if (index1 >= 0) {
                    this.formApplicantIncome.controls[index]['controls'].itemRows.removeAt(index1);
                  } else {
                    this.formArr.removeAt(index);
                  }
                }
              }
            } else {
              if (status == 'delete') {
                if (type == 'income') {
                  if (index1 >= 0) {

                    this.formApplicantIncome.controls[index]['controls'].itemRows.removeAt(index1);
                  } else {
                    this.formArr.removeAt(index);
                  }
                }
              }
            }
          }
        }
      ]
    });
    alert.present();
  }

  SaveImageRef(filePath, file) {
    return {
      task: this.storage.upload(filePath, file),
      ref: this.storage.ref(filePath)
    };
  }

  uploadImage(event, uid, i, i1) {
    debugger;
    this.upload_index=i;
    const thiss = this;
    if (event.target.files.length > 0) {
      Object.keys(event.target.files).forEach(function (key) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[key]);
        reader.onload = (e: any) => {
          console.log(event.target.files)
          const fileraw = event.target.files[key];
          const filePath = '/sallary_payslip/' + uid + '/' + (Math.floor(1000 + Math.random() * 9000) + 1);
          const result = thiss.SaveImageRef(filePath, fileraw);

          result.task.percentageChanges().subscribe(
            (value: number) => {
              thiss.uploadProgress = value
              thiss.fileuploadstatus = false;

            },
          );

          const ref = result.ref;
          if (key == '0') {
            thiss.percentage_0 = result.task.percentageChanges();
          } else if (key == '1') {
            thiss.percentage_1 = result.task.percentageChanges();
          } else if (key == '2') {
            thiss.percentage_2 = result.task.percentageChanges();
          } else if (key == '3') {
            thiss.percentage_3 = result.task.percentageChanges();
          } else if (key == '4') {
            thiss.percentage_4 = result.task.percentageChanges();
          } else if (key == '5') {
            thiss.percentage_5 = result.task.percentageChanges();
          }

          result.task.then(a => {
            ref.getDownloadURL().subscribe(a => {

              thiss.fileuploadstatus = true;
              // event.target.files[key].name = '';
              // console.log(event.target.files[key]);
              if (i1 >= 0) {
                if (key == '0') {
                  if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_0').value != '') {
                    if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_1').value != '') {
                      if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != '') {
                        if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != '') {
                          if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != '') {
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                          } else {
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                          }
                        } else {
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                        }
                      } else {
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                      }
                    } else {
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_1.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_1.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_0.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_0.setValue(event.target.files[key].name);
                  }
                } else if (key == '1') {
                  if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_1').value != '') {
                    if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != '') {
                      if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != '') {
                        if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != '') {
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                        } else {
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                        }
                      } else {
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                      }
                    } else {
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_1.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_1.setValue(event.target.files[key].name);
                  }
                } else if (key == '2') {
                  if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != '') {
                    if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != '') {
                      if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != '') {
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                      } else {
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                      }
                    } else {
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                  }
                } else if (key == '3') {
                  if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != '') {
                    if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != '') {
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                    } else {
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                  }
                } else if (key == '4') {
                  if (thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != '') {
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                  } else {
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                  }
                } else if (key == '5') {
                  thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                  thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                }

              } else {
                if (key == '0') {
                  if (thiss.formArr.controls[i].get('sallary_payslip_0').value != '') {
                    if (thiss.formArr.controls[i].get('sallary_payslip_1').value != '') {
                      if (thiss.formArr.controls[i].get('sallary_payslip_2').value != '') {
                        if (thiss.formArr.controls[i].get('sallary_payslip_3').value != '') {
                          if (thiss.formArr.controls[i].get('sallary_payslip_4').value != '') {
                            thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                            thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                          } else {
                            thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                            thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                          }
                        } else {
                          thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                        }
                      } else {
                        thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                      }
                    } else {
                      thiss.formArr.controls[i]['controls'].sallary_payslip_1.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formArr.controls[i]['controls'].sallary_payslip_0.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_0.setValue(event.target.files[key].name);
                  }
                } else if (key == '1') {
                  if (thiss.formArr.controls[i].get('sallary_payslip_1').value != '') {
                    if (thiss.formArr.controls[i].get('sallary_payslip_2').value != '') {
                      if (thiss.formArr.controls[i].get('sallary_payslip_3').value != '') {
                        if (thiss.formArr.controls[i].get('sallary_payslip_4').value != '') {
                          thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                        } else {
                          thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                        }
                      } else {
                        thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                      }
                    } else {
                      thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formArr.controls[i]['controls'].sallary_payslip_1.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue(event.target.files[key].name);
                  }
                } else if (key == '2') {
                  if (thiss.formArr.controls[i].get('sallary_payslip_2').value != '') {
                    if (thiss.formArr.controls[i].get('sallary_payslip_3').value != '') {
                      if (thiss.formArr.controls[i].get('sallary_payslip_4').value != '') {
                        thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                      } else {
                        thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                      }
                    } else {
                      thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                  }
                } else if (key == '3') {
                  if (thiss.formArr.controls[i].get('sallary_payslip_3').value != '') {
                    if (thiss.formArr.controls[i].get('sallary_payslip_4').value != '') {
                      thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                    } else {
                      thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                    }
                  } else {
                    thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                  }
                } else if (key == '4') {
                  if (thiss.formArr.controls[i].get('sallary_payslip_4').value != '') {
                    thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                  } else {
                    thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                  }
                } else if (key == '5') {
                  thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                  thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                }
              }
              //thiss.signupSlider.resize();
              //thiss.signupSlider.update();
              //thiss.myInputVariable.nativeElement.value = "";

                // if(thiss.uploadProgress == 100) {
                //     if(event.target.files[key].name) {
                //           //event.target.value="";
                //     }

                // }



            });
          });

        }, error => {
          console.log(error);
        }
      });

      //thiss.myInputVariable.nativeElement.value = "";
    }
    // setTimeout(()=>{                           //<<<---using ()=> syntax
    //   event.srcElement.value = null;
    //   }, 3000);

  }

  public changeType($event, type, i, i1) {
    debugger;
    if($event.target.value == 'Salary'){
      if(i1 == 'main'){
        if(this.userRole == 'contact') {
          this.formArr.controls[i]['controls'].sallary_payslip_0.setValidators(Validators.required);
          this.formArr.controls[i]['controls'].sallary_payslip_0.updateValueAndValidity();
        }

      }else{
        if(this.userRole == 'contact') {
          this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.setValidators(Validators.required);
          this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.updateValueAndValidity();
        }

      }

    }else{
      if(i1 == 'main'){

        if(this.userRole == 'contact') {
          this.formArr.controls[i]['controls'].sallary_payslip_0.clearValidators();
          this.formArr.controls[i]['controls'].sallary_payslip_0.updateValueAndValidity();
        }

      }else{
        if(this.userRole == 'contact') {
          this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.clearValidators();
          this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.updateValueAndValidity();
        }

      }

    }
    // this.signupSlider.resize();
    // this.signupSlider.update();

    this.new_val = $event.target.value;
    this.old_val = '';
    var property = '';
    if (type == 'type') {
      if (this.allIncomess.length > i) {
        this.old_val = this.allIncomess[i].type;
      } else {
        this.old_val = '';
      }
      if (this.old_val == undefined) {
        this.old_val = '';
      }
      property = 'Type';
    }
    if (this.new_val != this.old_val) {
      this.income_details.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': i });
    }
    this.income_details.sort((a, b) => a.index > b.index);
  }

  payslip_remove(postion, i, status) {
    let alert = this.alertCtrl.create({
      title: 'Confirm remove payslip',
      message: 'Are you sure you want to remove this payslip ?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (status == "main") {
              if (postion == 0) {
                this.formArr.controls[i]['controls'].sallary_payslip_0.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_0.setValue("");
              } else if (postion == 1) {
                this.formArr.controls[i]['controls'].sallary_payslip_1.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue("");
              } else if (postion == 2) {
                this.formArr.controls[i]['controls'].sallary_payslip_2.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue("");
              } else if (postion == 3) {
                this.formArr.controls[i]['controls'].sallary_payslip_3.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue("");
              } else if (postion == 4) {
                this.formArr.controls[i]['controls'].sallary_payslip_4.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue("");
              } else if (postion == 5) {
                this.formArr.controls[i]['controls'].sallary_payslip_5.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue("");
              }
              // const docRef = firebase.firestore().collection('/SDF_income');
              // if (this.formArr.controls[i].get('document_id').value == '' || this.formArr.controls[i].get('document_id').value == null || this.formArr.controls[i].get('document_id').value == undefined) { } else {
              //   if (postion == 0) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_0: ''
              //     });
              //   } else if (postion == 1) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_1: ''
              //     });
              //   } else if (postion == 2) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_2: ''
              //     });
              //   } else if (postion == 3) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_3: ''
              //     });
              //   } else if (postion == 4) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_4: ''
              //     });
              //   } else if (postion == 5) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_5: ''
              //     });
              //   }
              // }
            } else if (status >= 0) {
              if (postion == 0) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_0.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_0.setValue("");
              } else if (postion == 1) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_1.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_1.setValue("");
              } else if (postion == 2) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_2.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_2.setValue("");
              } else if (postion == 3) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_3.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_3.setValue("");
              } else if (postion == 4) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_4.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_4.setValue("");
              } else if (postion == 5) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_5.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_5.setValue("");
              }
              // const docRef = firebase.firestore().collection('/SDF_income');
              // if (this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == '' || this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == null || this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == undefined) { } else {
              //   if (postion == 0) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_0: ''
              //     });
              //   } else if (postion == 1) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_1: ''
              //     });
              //   } else if (postion == 2) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_2: ''
              //     });
              //   } else if (postion == 3) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_3: ''
              //     });
              //   } else if (postion == 4) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_4: ''
              //     });
              //   } else if (postion == 5) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_5: ''
              //     });
              //   }
              // }
            }


          }
        }
      ]
    });
    alert.present();
  }

  getValue() {
    //this.additionalForm.get
    console.log(this.incomeForm.value);
    //console.log(this.formArrApplicantAddress.controls.city.value;
    this.valueChange.emit(this.incomeForm.value);

  }

  getRoleStartDate(date) {
    debugger;
    console.log(this.formArr);
    if(this.formArr.length > 0) {
       if(this.formArr.at(0).value.date_commenced == '' || this.formArr.at(0).value.date_commenced == null) {
        this.formArr.controls[0]['controls'].date_commenced.setValue(date);
        //this.formArr.at(0).setValue('date_commenced',date);
       }

    }
    this.date = date;
  }





}




// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/component/employment-and-incomedetails/income-details/income_details.ts